/**
 * Utilities for persisting game data to localStorage
 */

// Constants for localStorage keys
const JOKES_STORAGE_KEY = 'school-tower-defense-jokes';

// Interface for stored jokes
interface StoredJokes {
  [towerId: string]: string[];
}

/**
 * Save jokes for a specific tower to localStorage
 * @param towerId The ID of the tower
 * @param jokes Array of jokes to save
 */
export const saveJokesToStorage = (towerId: string, jokes: string[]): void => {
  try {
    // Get existing jokes from storage
    const existingJokesJson = localStorage.getItem(JOKES_STORAGE_KEY);
    let allJokes: StoredJokes = {};
    
    if (existingJokesJson) {
      allJokes = JSON.parse(existingJokesJson);
    }
    
    // Update jokes for this tower
    allJokes[towerId] = jokes;
    
    // Save back to localStorage
    localStorage.setItem(JOKES_STORAGE_KEY, JSON.stringify(allJokes));
    console.log(`Saved ${jokes.length} jokes for tower ${towerId} to localStorage`);
  } catch (error) {
    console.error('Error saving jokes to localStorage:', error);
  }
};

/**
 * Get jokes for a specific tower from localStorage
 * @param towerId The ID of the tower
 * @returns Array of jokes or empty array if none found
 */
export const getJokesFromStorage = (towerId: string): string[] => {
  try {
    const jokesJson = localStorage.getItem(JOKES_STORAGE_KEY);
    if (!jokesJson) return [];
    
    const allJokes: StoredJokes = JSON.parse(jokesJson);
    return allJokes[towerId] || [];
  } catch (error) {
    console.error('Error loading jokes from localStorage:', error);
    return [];
  }
};

/**
 * Get all saved jokes from localStorage
 * @returns Object with tower IDs as keys and joke arrays as values
 */
export const getAllJokesFromStorage = (): StoredJokes => {
  try {
    const jokesJson = localStorage.getItem(JOKES_STORAGE_KEY);
    if (!jokesJson) return {};
    
    return JSON.parse(jokesJson);
  } catch (error) {
    console.error('Error loading all jokes from localStorage:', error);
    return {};
  }
};

/**
 * Clear all saved jokes from localStorage
 */
export const clearAllJokesFromStorage = (): void => {
  try {
    localStorage.removeItem(JOKES_STORAGE_KEY);
    console.log('Cleared all jokes from localStorage');
  } catch (error) {
    console.error('Error clearing jokes from localStorage:', error);
  }
}; 